export default __webpack_public_path__ + "static/10-cyborg-90aa7863a587682b4554b1c0d45eec3e.png";